export default __webpack_public_path__ + "static/media/Background_00184.4a733391.png";